import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { SkillMap } from '../types/mastery';
import { updateSkillMap, getWeakSkills } from '../engine/mastery-engine';

interface MasteryState {
  skillMaps: Record<string, SkillMap>;
  updateMastery: (
    childId: string,
    futureSkills: string[],
    subject: string,
    stars: 1 | 2 | 3,
    difficulty: 1 | 2 | 3,
    date: string,
  ) => SkillMap;
  getSkillMap: (childId: string) => SkillMap;
  getWeakSkills: (childId: string, count?: number) => string[];
}

export const useMasteryStore = create<MasteryState>()(
  persist(
    (set, get) => ({
      skillMaps: {},

      updateMastery: (childId, futureSkills, subject, stars, difficulty, date) => {
        const current = get().skillMaps[childId] || {};
        const updated = updateSkillMap(current, futureSkills, subject, stars, difficulty, date);
        set(state => ({
          skillMaps: { ...state.skillMaps, [childId]: updated },
        }));
        return updated;
      },

      getSkillMap: (childId) => {
        return get().skillMaps[childId] || {};
      },

      getWeakSkills: (childId, count = 5) => {
        const map = get().skillMaps[childId] || {};
        return getWeakSkills(map, count);
      },
    }),
    { name: 'homeschool-mastery', version: 0, migrate: (state) => state }
  )
);
